import { Pipe, PipeTransform } from '@angular/core';
import Big from 'big-js';
import { formatCurrencyNumber } from '../helpers/util-helper';

interface CoinException {
  code: string;
  decimals: number;
}

@Pipe({
  standalone: false,name: 'decimalNumber'})
export class DecimalNumberPipe implements PipeTransform {

  static coinExceptions: Array<CoinException> = [
    { code: 'zar', decimals: 2 },
    { code: 'usdt', decimals: 8 },
  ];

  transform(value: any, decimal: any, coin_code: string): string {
    let converted;
    if (typeof value === 'string') {
      converted = Number(value);
      if (isNaN(converted)) {
        return value;
      } else {
        value = converted;
      }
    }
    if (typeof decimal === 'string') {
      converted = Number(decimal);
      if (isNaN(converted)) {
        decimal = 8;
      } else {
        decimal = converted;
      }
    } // adding this in so that the pipe doesn't break on strings

    let decimalSpaces: number = !!decimal ? decimal : 8;

    coin_code = !!coin_code ? coin_code.toLowerCase() : '';


    const exception: CoinException = DecimalNumberPipe.coinExceptions.find(ce => ce.code === coin_code);

    if (!!exception) {
      decimalSpaces = exception.decimals;
    }

    let result: string = (0).toFixed(decimalSpaces);
    if (!!value) {
      const ten = new Big(10);
      const multiplier = ten.pow(decimalSpaces);

      let valueT = new Big(Number(value));
      valueT = new Big(Number(Math.floor(valueT.times(multiplier))));
      valueT = valueT.div(multiplier);
      result = valueT.toFixed(decimalSpaces);
    }
    return result;
  }
}

@Pipe({
  standalone: false,name: 'currencyNumber'})
export class CurrencyNumberPipe implements PipeTransform {

  transform(value: string | number, maxDecimals: number = 8, minDecimals: number = 2): string {
    if (typeof value === 'string' && isNaN(Number(value))) {
      return value;
    }

    return formatCurrencyNumber(value, maxDecimals, minDecimals);
  }
}
